import './table.less';
import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';
import { Link } from 'react-router';
import moment from 'moment';
import noop from 'lodash/noop';

const Table = ({
	table,
	intl,
	sortByColumn,
	showMoreRows,
	remove,
	can
}) => (
	<div className="table-container table-container--projector payout-system-table">
		<div className="table-container--projector__body">
			<div className="table-container--projector__body-content">
				<table className="simple-table simple-table--static">
					<thead className="simple-table__head font-roboto-medium">
						<tr>
							{ table.headers.map((header, i) => (
								<th
									key={i}
									className={cn({
										'sort-header': header.direction,
										'active': table.sortedColumn.index === header.index,
										[header.className]: header.className,
										[table.sortedColumn.direction]: (
											table.sortedColumn.index === header.index && table.sortedColumn.direction
										)
									})}
									onClick={() => header.direction ? sortByColumn(header.index) : noop}>{intl(header.title)}</th>
							))}
						</tr>
					</thead>

					<tbody className="simple-table__body">
						{ table.rows.map((row, i) => (
							<tr key={i}>
								<td className="id"><span>{ row.id }</span></td>
								<td className="title"><span>{ `${row.title} (${row.currency})` }</span></td>
								<td><span>{ row.status }</span></td>
								<td className="datetime">
									<span className="date">{ moment(row.created_at).format('DD.MM.YYYY') }</span>
									<span className="at">{intl('at')}</span>
									<span className="time">{ moment(row.created_at).format('HH:mm') }</span>
								</td>
								<td className="datetime">
									<span className="date">{ moment(row.updated_at).format('DD.MM.YYYY') }</span>
									<span className="at">{intl('at')}</span>
									<span className="time">{ moment(row.updated_at).format('HH:mm') }</span>
								</td>
								<td className="actions">
									<Link to={`payout-systems/edit/${row.id}`} className="action_edit" />

									{can('delete') && (
										<a
											className="action_delete"
											onClick={(e) => {
												e.preventDefault();
												if (confirm(`${intl('Remove payout system')} ${row.title}?`)) {
													remove(row.id);
												}
											}}
										/>
									)}
								</td>
							</tr>
						)) }
					</tbody>
				</table>
			</div>
		</div>

		<div className="table-container__navigation">
			{ table.totalRows > table.rowsNumber && (
				<button className="ui-btn ui-btn-secondary" onClick={() => showMoreRows()}>{intl('Show more')}</button>
			)}
		</div>
	</div>
);

Table.propTypes = {
	table: PropTypes.object,
	intl: PropTypes.func,
	sortByColumn: PropTypes.func,
	showMoreRows: PropTypes.func,
	remove: PropTypes.func,
	can: PropTypes.func
};

export default Table;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payout-systems/components/table.js